import { memo } from 'react';
import { Avatar } from 'antd';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import moment from 'moment';
import DefaultLogo from 'assets/images/logovietgrp.svg';
import UserStatusIndicator from 'components/UserStatusIndicator';
import './styles.less';
import { isArray } from 'lodash';
import { TagOutlined, DeleteOutlined } from '@ant-design/icons';

const ConversationCell = ({ data, onClick, className = '', currentUserId, onClickTag, onDeleteTag }) => {
  const messageCreatedDate = _get(data, 'latestMessage.createdAt');
  const unseenMessages = _get(data, 'unseenMessages');
  const user = _get(data, 'users[0]', {});
  const tags = _get(data, 'tags', []);
  const avatar = _get(user, 'userDetail.avatar') || DefaultLogo;
  const online = _get(user, 'online', 0);
  const lastSeen = _get(user, 'lastSeen', null);

  // DEBUG: Log avatar data
  console.log('[ConversationCell] user:', user.name, 'avatar:', _get(user, 'userDetail.avatar'), 'userDetail:', user.userDetail);

  // Check if latest message is from admin using isAdmin field
  const isLatestMessageFromAdmin = _get(data, 'latestMessage.isAdmin') === 1;

  // Check if conversation is read but admin hasn't replied
  const isReadButNoAdminReply = !unseenMessages && !isLatestMessageFromAdmin;

  const latestSenderName = _get(data, 'latestMessage.sender') !== currentUserId ? user.name : 'Bạn';
  let latestMessage = _get(data, 'latestMessage.text');
  if (!_isEmpty(_get(data, 'latestMessage.attachments', []))) {
    latestMessage = `${latestSenderName} vừa gửi tệp`;
  } else if (_get(data, 'latestMessage.type') === 'product') {
    latestMessage = `${latestSenderName} vừa gửi sản phẩm`;
  }

  // Get valid tags (non-empty names)
  const validTags = isArray(tags) ? tags.filter((tag) => tag && tag.name.trim() !== '') : [];

  return (
    <div
      className={`conversation-cell-container ${className} ${unseenMessages ? 'unseen-conversation' : ''}`}
      onClick={onClick}
    >
      <div className="avatar-status-wrapper">
        <Avatar size={40} src={avatar} className="avatar" />
        <UserStatusIndicator online={online} lastSeen={lastSeen} size="sm" />
      </div>
      <div className="conversation-cell-content">
        <div className="username-row">
          <span className="username">{user.name}</span>
          {isReadButNoAdminReply && (
            <span className="unread-indicator">
              <span className="unread-dot"></span>
              Chưa trả lời
            </span>
          )}
        </div>
        <div className="last-message">{latestMessage}</div>
        <div className="message-date">
          {messageCreatedDate ? moment(messageCreatedDate).format('DD/MM/YY') : ''}{' '}
          {messageCreatedDate ? moment(messageCreatedDate).format('h:mmA') : ''}
        </div>
      </div>
      <div className="action-section">
        {validTags.length > 0 && (
          <div className="tags-inline">
            {validTags.map((tag, index) => (
              <span key={index} className="tag-label" style={{ color: tag.color }}>
                {tag.name}
              </span>
            ))}
          </div>
        )}
        <div
          className="tag-icon"
          style={validTags.length > 0 ? { color: validTags[0].color } : {}}
          onClick={(e) => {
            e.stopPropagation();
            onClickTag && onClickTag(data);
          }}
        >
          <TagOutlined />
        </div>
        <div
          className="delete-icon"
          onClick={(e) => {
            e.stopPropagation();
            onDeleteTag && onDeleteTag(data);
          }}
        >
          <DeleteOutlined />
        </div>
      </div>
    </div>
  );
};

ConversationCell.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  currentUserId: PropTypes.string.isRequired,
};

export default memo(ConversationCell);
